document.addEventListener('DOMContentLoaded', function () {
  var body = document.querySelector('.article-body');
  if (!body) return;

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
  var tocList = document.getElementById('article-toc-list');
  var tocWrap = document.getElementById('article-toc-wrap');
  var usedIds = {};

  function slugify(text) {
    var s = text.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (usedIds[s]) {
      usedIds[s] += 1;
      s = s + '-' + usedIds[s];
    } else {
      usedIds[s] = 1;
    }
    return s || 'section';
  }

  if (tocList && headings.length) {
    var links = [];
    headings.forEach(function (h) {
      var id = slugify(h.textContent);
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
      links.push(a);
    });
    if (tocWrap) tocWrap.style.display = '';

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var link = tocList.querySelector('a[href="#' + entry.target.id + '"]');
          if (!link || !entry.isIntersecting) return;
          links.forEach(function (l) { l.classList.remove('is-active'); });
          link.classList.add('is-active');
        });
      }, { rootMargin: '-15% 0px -70% 0px' });
      headings.forEach(function (h) { observer.observe(h); });
    }
  }

  var faqHeading = headings.filter(function (h) {
    return /frequently asked questions/i.test(h.textContent);
  })[0];

  if (faqHeading) {
    var wrap = document.createElement('div');
    wrap.className = 'faq-accordion';
    var node = faqHeading.nextElementSibling;
    while (node && node.tagName === 'P' && node.querySelector('strong')) {
      var next = node.nextElementSibling;
      var strongEl = node.querySelector('strong');
      var question = strongEl.textContent;
      var html = node.innerHTML;
      var brMatch = html.match(/<br\s*\/?>/i);
      var answerHtml = brMatch
        ? html.slice(html.indexOf(brMatch[0]) + brMatch[0].length)
        : html.replace(/<strong>[\s\S]*?<\/strong>/, '');
      var details = document.createElement('details');
      details.className = 'faq-item';
      var summary = document.createElement('summary');
      summary.textContent = question;
      var answer = document.createElement('p');
      answer.innerHTML = answerHtml.trim();
      details.appendChild(summary);
      details.appendChild(answer);
      wrap.appendChild(details);
      node.remove();
      node = next;
    }
    if (wrap.children.length) {
      faqHeading.insertAdjacentElement('afterend', wrap);
    }
  }
});
